import getHtmlParam from '../../utilities/htmlParam';

declare var productArticles: any;
declare var tonerType: boolean;

const mp = getHtmlParam('.js-mp .param');
const param = getHtmlParam('.js-param .param');

export class Search {

  parseHTML(str: string) {
    const tmp = document.implementation.createHTMLDocument(null);
    tmp.body.innerHTML = str;
    return tmp.body.children;
  };

  applyPage(form: HTMLFormElement, page: string) {
    const inputPage = form.querySelector('input[name="page"]');
    inputPage && inputPage.parentNode.removeChild(inputPage);
    const input = document.createElement('input');
    input.type = 'hidden';
    input.setAttribute('name', 'page');
    input.value = page;
    form.appendChild(input);
  }

  getNextHiddenFilterInputIndex(form: HTMLFormElement) {
    let nextIndex = 0;

    // search inputs with name='filter[123].name
    form.querySelectorAll("input[name^='filters['][name$='.name']").forEach((input: HTMLInputElement) => {
      const index = parseInt(/\[(\d+)]/.exec(input.name)[1]) || 0;
      if (nextIndex <= index) {
        nextIndex = index + 1;
      }
    });

    return nextIndex;
  }

  getPreviousSibling(elem: Element, selector: string) {

    // Get the next sibling element
    let sibling = elem.previousElementSibling;

    // If there's no selector, return the first sibling
    if (!selector) return sibling;

    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
      if (sibling.matches(selector)) return sibling;
      sibling = sibling.previousElementSibling;
    }

  }

  appendHiddenFilterInput(form: HTMLFormElement, index: number, name: string, value: string, id: string, baseId: string) {
    const input1 = document.createElement('input');
    input1.type = 'hidden';
    input1.name = 'filters[' + index + '].name';
    input1.value = name;
    form.appendChild(input1);

    const input2 = document.createElement('input');
    input2.type = 'hidden';
    input2.name = 'filters[' + index + '].value';
    input2.value = value;
    form.appendChild(input2);

    const input3 = document.createElement('input');
    input3.type = 'hidden';
    input3.name = 'filters[' + index + '].id';
    input3.value = id;
    form.appendChild(input3);

    const input4 = document.createElement('input');
    input4.type = 'hidden';
    input4.name = 'filters[' + index + '].baseId';
    input4.value = baseId;
    form.appendChild(input4);
  }

  appendHiddenFilterRangeInput(form: HTMLFormElement, index: number, name: string, value: any, baseId: string) {
    let valueMin = value.valueMin;
    let valueMax = value.valueMax;

    if (typeof value.valueMin === 'undefined' || value.valueMin === '') {
      const filterMin = form.querySelector('input[data-filter-name="' + name + '"][min]');
      if (filterMin) {
        valueMin = filterMin.getAttribute('min');
      }
    }
    if (typeof value.valueMax === 'undefined' || value.valueMax === '') {
      const filterMax = form.querySelector('input[data-filter-name="' + name + '"][max]');
      if (filterMax) {
        valueMax = filterMax.getAttribute('max');
      }
    }

    const input1 = document.createElement('input');
    input1.type = 'hidden';
    input1.name = 'filters[' + index + '].baseId';
    input1.value = baseId;
    form.appendChild(input1);

    const input2 = document.createElement('input');
    input2.type = 'hidden';
    input2.name = 'filters[' + index + '].name';
    input2.value = value.name;
    form.appendChild(input2);

    const input3 = document.createElement('input');
    input3.type = 'hidden';
    input3.name = 'filters[' + index + '].valueMin';
    input3.value = valueMin;
    form.appendChild(input3);

    const input4 = document.createElement('input');
    input4.type = 'hidden';
    input4.name = 'filters[' + index + '].valueMax';
    input4.value = valueMax;
    form.appendChild(input4);

    const input5 = document.createElement('input');
    input5.type = 'hidden';
    input5.name = 'filters[' + index + '].id';
    input5.value = value.id;
    form.appendChild(input5);
  }

  applySelectedFilters(form: HTMLFormElement) {
    let sliderValues: any = {};
    let filterBasetype = '';

    let nextIndex = this.getNextHiddenFilterInputIndex(form);
    form.querySelectorAll('input[data-filter-name]').forEach((input: HTMLInputElement) => {
      const name = input.dataset.filterName;
      const id = input.dataset.filterId;
      const value = input.value;
      const style = input.dataset.filterStyle;
      const filterType = input.dataset.filterType;
      filterBasetype = input.dataset.filterBasetype;
      switch (style) {
        case 'SLIDER':
          if (typeof value !== 'undefined' && value !== '') {
            if (typeof sliderValues[name] === 'undefined') {
              sliderValues[name] = [];
            }
            sliderValues[name]['name'] = name;
            sliderValues[name]['id'] = id;
            if (filterType === 'min') {
              sliderValues[name]['valueMin'] = value;
            }
            if (filterType === 'max') {
              sliderValues[name]['valueMax'] = value;
            }
          }
          break;
        case 'MULTISELECT':
        case 'RADIOSELECT':
        case 'DEFAULT':
          if (input.checked) {
            this.appendHiddenFilterInput(form, nextIndex, name, value, id, filterBasetype);
            nextIndex++;
          }
          break;
        default:
          console.error('Unknown filter style: ' + style);
      }
    });

    sliderValues && Object.entries(sliderValues).forEach(([key, value]) => {
      this.appendHiddenFilterRangeInput(form, nextIndex, key, value, filterBasetype);
      nextIndex++;
    });
  }

  loadArticleDetails(product: string, article: string, image: string, url: string) {
    const articleItem: HTMLElement = document.querySelector('div[id=' + product + ']');
    const activeArticle = articleItem.querySelector('.pues-product-colors');
    let activeArticleId = '';
    activeArticle && (activeArticleId = activeArticle.getAttribute('data-active-article-id'));

    if (activeArticleId !== article) {
      activeArticle && activeArticle.setAttribute('data-active-article-id', article);

      if (typeof image !== 'undefined' && image !== '') {
        const productImage = document.querySelector('#' + product + ' .product-item-image img');
        const productImageSource = document.querySelector('#' + product + ' .product-item-image source');
        productImage && productImage.setAttribute('src', image);
        productImageSource && productImageSource.setAttribute('srcset', image);
      }

      const linkTitle = document.querySelector('#' + product + ' a.js-logging-link-title');
      linkTitle && (linkTitle.textContent = productArticles[article]['articleLinkText']);
      // fastDelivery budget
      const articleElement = document.querySelector('#' + product);
      const budgetBadge = document.querySelector('#' + product + ' .product-item-budget-badge');
      if (budgetBadge) {
        if (typeof productArticles[article]['budgetBurner'] !== 'undefined' && productArticles[article]['budgetBurner'] === true) {
          (budgetBadge as HTMLElement).style.display = 'block';
          articleElement.classList.add('product-item-budget');
        } else {
          (budgetBadge as HTMLElement).style.display = 'none';
          articleElement.classList.remove('product-item-budget');
        }
      }

      const fastBadge = document.querySelector('#' + product + ' .product-item-fast-badge');
      if (fastBadge) {
        if (typeof productArticles[article]['fastDelivery'] !== 'undefined' && productArticles[article]['fastDelivery'] === true) {
          (fastBadge as HTMLElement).style.display = 'block';
          articleElement.classList.add('product-item-fast');
        } else {
          (fastBadge as HTMLElement).style.display = 'none';
          articleElement.classList.remove('product-item-fast');
        }
      }

      const productLogging = document.querySelector('#' + product + ' .js-logging-link-button');
      if (productLogging) {
        articleElement.querySelector('a.js-logging-link-button').setAttribute('href', productArticles[article]['articleLinkButton']);
        articleElement.querySelector('a.js-logging-link-image').setAttribute('href', productArticles[article]['articleLinkImage']);
        articleElement.querySelector('a.js-logging-link-brand').setAttribute('href', productArticles[article]['articleLinkBrand']);
        articleElement.querySelector('a.js-logging-link-title').setAttribute('href', productArticles[article]['articleLinkTitle']);

        articleElement.querySelector('a.js-logging-link-delivery-price').setAttribute('href', productArticles[article]['articleLinkDeliveryPrice']);
      }

      const deliveryTime = articleItem.querySelector('.delivery-time');
      const alertMessage = articleItem.querySelector('.not-available');

      // on hover colors:
      const deliveyPeriodText = productArticles[article]['deliveryTime'];
      const deliveyPeriod = parseInt(productArticles[article]['deliveyPeriod']);
      const notAvailble = productArticles[article]['isTemporarilyNotAvailable'];

      if (deliveyPeriodText && deliveyPeriodText !== '') {
        const articleDelivery = articleItem.querySelector('.js-pues-article-delivery');
        articleDelivery && (articleDelivery.innerHTML = deliveyPeriodText);
        if (deliveyPeriod > 10) {
          articleDelivery && articleDelivery.classList.add('fc-grey');
        } else {
          articleDelivery && articleDelivery.classList.remove('fc-grey');
        }
      }
      if (notAvailble && notAvailble === 'true') {
        deliveryTime && ((deliveryTime as HTMLElement).style.display = 'none');
        alertMessage && ((alertMessage as HTMLElement).style.display = 'inline');
      } else {
        deliveryTime && ((deliveryTime as HTMLElement).style.display = 'inline');
        alertMessage && ((alertMessage as HTMLElement).style.display = 'none');
      }

      const deliveryPrice = document.querySelector('div[id="' + product + '"] .js-logging-link-delivery-price');
      deliveryPrice && (deliveryPrice.innerHTML = productArticles[article]['articlePrice']);

      // update article ID on item container
      articleItem.dataset.articleId = article;

      // update energy label
      const energylabelWrapper: HTMLElement = articleItem.querySelector('.energylabel');
      if (!energylabelWrapper) return;
      const energylabelOpen = articleItem.querySelector('.energylabel .energylabel-open');
      const energylabelPdf: HTMLAnchorElement = articleItem.querySelector('.energylabel .energylabel-pdf');
      const energylabelThumb: HTMLImageElement = articleItem.querySelector('.energylabel .energylabel-open img');
      const energylabelVariants = articleItem.querySelector('.energylabel-variants');

      if (energylabelVariants && energylabelVariants.getAttribute('data-thumbsrc-' + article)) {
        energylabelThumb.src = energylabelVariants.getAttribute('data-thumbsrc-' + article);
        energylabelWrapper.style.display = 'flex';

        if (energylabelOpen && energylabelVariants.getAttribute('data-imgsrc-' + article)) {
          energylabelOpen.setAttribute('data-imgsrc', energylabelVariants.getAttribute('data-imgsrc-' + article));
        }
        if (energylabelOpen && energylabelPdf && energylabelVariants.getAttribute('data-pdfsrc-' + article)) {
          energylabelOpen.setAttribute('data-pdfsrc', energylabelVariants.getAttribute('data-pdfsrc-' + article));
          energylabelPdf.href = energylabelVariants.getAttribute('data-pdfsrc-' + article);
          energylabelPdf.style.display = 'block';
        } else {
          energylabelPdf.style.display = 'none';
        }
      } else {
        energylabelWrapper.style.display = 'none';
      }
    }
  }

  serialize(form: HTMLFormElement) {
    let field, l, s = [];
    if (typeof form === 'object' && form.nodeName === 'FORM') {
      const len = form.elements.length;
      for (let i = 0; i < len; i++) {
        field = form.elements[i] as HTMLFormElement;
        if (field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit' && field.type !== 'button') {
          if (field.type === 'select-multiple') {
            l = (form.elements[i] as HTMLFormElement).options.length;
            for (let j = 0; j < l; j++) {
              if (field.options[j].selected)
                s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[j].value);
            }
          } else if ((field.type !== 'checkbox' && field.type !== 'radio') && field.value || field.checked && field.value) {
            s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value);
          }
        }
      }
    }
    return s.join('&').replace(/%20/g, '+');
  }

  async updateResult(catId?: string, searchTerm?: string, params?: string, filter?: boolean) {
    const puesType = param.get('puesType');
    let url = '';
    if (puesType === 'BRAND_PUES') {
      url = '/product/brand/brand-partial/' + searchTerm.toLowerCase();
    }
    if (puesType === 'SEARCH_PUES') {
      url = '/product/search/search-partial';
    }
    if (puesType === 'CATEGORY_PUES') {
      url = '/product/category-partial/' + catId;
    }
    if (tonerType) {
      url = '/product/ink-toner/search';
    }

    const pageUrl = location.protocol + '//' + location.host + location.pathname;

    let onlyFilter = '';
    filter && (onlyFilter = '&filterPopup=true');

    return await window.fetch(param.get('urlPrefix') + url + '?' + params + onlyFilter, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({curPage: pageUrl}),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.text();
        }
      })
      .then((data) => {
        return document.createRange().createContextualFragment(data);
      })
  }
}
